import { DestroyRef, inject, Injectable } from "@angular/core";
import { BehaviorSubject, Subject, Subscription, debounceTime } from "rxjs";
import { HeartbeatService, UserPresence } from "../../../../services/heartbeat.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root'
})

export class UserPresenceService {
  private destroyRef = inject(DestroyRef);

  private userPresenceIdsTrackingSubject = new BehaviorSubject<number[] | null>(null);
  private userPresences: UserPresence[] | null = null;
  private heartbeatSubscription = new Subscription();
  private fetchPresenceTrigger = new Subject<void>();

  userPresenceIdsTracking$ = this.userPresenceIdsTrackingSubject.asObservable();

  constructor(
    private heartbeatService: HeartbeatService,
  ) {
    this.setupUserPresenceInterval();
    this.setupDebouncedFetch();
  }

  private setupDebouncedFetch() {
    this.fetchPresenceTrigger.pipe(
      debounceTime(300),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.getUserPresence();
    });
  }

  private setupUserPresenceInterval() {
    setInterval(() => {
      this.getUserPresence();
    }, 3 * 60 * 1000);
  }

  private getUserPresence() {
    const userIds = this.userPresenceIdsTrackingSubject.value;
    if (userIds && userIds.length > 0) {
      if (this.heartbeatSubscription) {
        this.heartbeatSubscription.unsubscribe();
      }
      this.heartbeatSubscription = this.heartbeatService.getPresences(userIds)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (presences) => {
            this.userPresences = presences;
            },
            error: (error) => {
            this.userPresences = [];
            if (error.status === 404) {
                return;
            } else {
                console.error('Error fetching user presences:', error);
            }
        }
      })
    }
  }

  addUserPresenceIdToTracking(userId: number) {
    const currentIds = this.userPresenceIdsTrackingSubject.value || [];
    if (userId && !currentIds.includes(userId)) {
      this.userPresenceIdsTrackingSubject.next([...currentIds, userId]);
      this.fetchPresenceTrigger.next();
    }
  }

  removeUserPresenceIdFromTracking(userId: number) {
    const currentIds = this.userPresenceIdsTrackingSubject.value || [];
    const updatedIds = currentIds.filter(id => id !== userId);
    this.userPresenceIdsTrackingSubject.next(updatedIds.length > 0 ? updatedIds : null);
  }
  
  getUserPresenceById(userId: number): UserPresence | null {
    if (this.userPresences) {
      return this.userPresences.find(p => p.UserId === userId) || null;
    }
    return null;
  }

}